import React from "react";
import { Box } from "@material-ui/core";
import SolutionCard from "./SolutionCard";

export class SolutionCardList extends React.Component {
  render() {
    return (
      <section>
        <Box
          sx={{
            display: "grid",
            gridAutoRows: "auto",
            gridGap: "20px",
            gridTemplateColumns: this.props.cards
              ?.map((_) => "minmax(300px, 1fr)")
              .join(" "),
          }}
        >
          {this.props.cards.map((card, key) => (
            <SolutionCard
              key={key}
              solutionsSelected={this.props.solutionsSelected}
              solutionsCodesSelected={this.props.solutionsCodesSelected}
              activeSolutions={this.props.activeSolutions}
              onSolutionsCodesChanges={this.props.onSolutionsCodesChanges}
              getSolutionsCodes={this.props.getSolutionsCodes}
              onSolutionToggle={this.props.onSolutionToggle}
              {...card}
            />
          ))}
        </Box>
      </section>
    );
  }
}
